exports = module.exports = require("../../node_modules/.pnpm/css-loader@2.1.1_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "h2[data-v-4fa8aadd]{font-size:40px;line-height:40px;font-weight:bold;color:#262626;margin:0}strong[data-v-4fa8aadd]{color:#3b3b3b;font-size:20px;padding-top:26px;padding-bottom:65px}", ""]);

